module.exports = __webpack_public_path__ + "static/media/screen_3.9e11853d.png";